export const iconFontAwesomeTextformattingBorderAll = (
	<i className="fa-solid fa-border-all"></i>
);
